import $ from 'jquery';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Moment from 'react-moment';
import limparUltimosHIstoricosUsuario from '../../../actions/usuario/limparUltimosHIstoricosUsuario';
import capitalizarTodasPrimeirasLetras from '../../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', borderBottom: '2px solid #FF6A00', color: '#0F0F0F' }}>
        <div>Data e Hora</div>
        <div>Histórico</div>
        <div>Responsável</div>
        <div>Perfis Atuais</div>
        <div>Telefone</div>
        <div>Ativo</div>
        <div>Bloqueado</div>
    </div>
);

export class ModalHistoricoUsuario extends Component {

    fecharModal() {
        $('#modalHistoricoUsuario')
            .modal('hide');
        $('#modalHistoricoUsuario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHIstoricosUsuario();
    }

    exibirItinerarioBloqueado(historico) {
        // eslint-disable-next-line no-undef
        if (historico.usuarioEmpresa && _.isNil(historico.usuarioEmpresa.bloqueado)) {
            if (historico.usuarioEmpresa.bloqueado) {
                return <p>Sim</p>
            } else {
                return <p>Não</p>
            }
        }
        return '';
    }

    formatarRoles(usuarioRoles) {
        const perfis = usuarioRoles.split(',');
        return perfis.map(it => (<p key={it} style={{padding: '0px', margin: '0px'}}> {it} </p>));
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => (
                <div key={`${historico.id}-${historico.dataEvento}`}
                     style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: '12px', alignItems: 'start' }}>
                    <div><Moment format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment></div>
                    <div>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</div>
                    <div>{historico.responsavel && historico.responsavel.nome}</div>
                    <div style={{ overflowY: 'auto', maxHeight: '50px' }}>
                        {historico.usuarioEmpresa != null ? this.formatarRoles(historico.usuarioEmpresa.usuarioRoles.replaceAll('ROLE_', '')) : null}
                    </div>
                    <div>{historico.usuario && historico.usuario.telefones ? historico.usuario.telefones : '-'}</div>
                    <div>{historico.usuarioEmpresa != null ? historico.usuarioEmpresa.ativo ? 'Sim' : 'Não' : null}</div>
                    <div>{this.exibirItinerarioBloqueado(historico)}</div>
                </div>
            ))
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoUsuario' role='dialog'
                 aria-labelledby='modalHistoricoUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">history</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">Histórico de Usuários</h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={() => this.fecharModal()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <Cabecalho/>
                            {this.exibirHistoricos()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        rotaSelecionada: state.rotaSelecionada,
        empresaSelecionada: state.empresaSelecionada,
        historicoUsuarioDtos: state.ultimosHistoricosUsuario.historicoUsuarioDtos,
        historicoUsuarioEmpresaDtos: state.ultimosHistoricosUsuario.historicoUsuarioEmpresaDtos,
        historicos: state.ultimosHistoricosUsuario.historicoUsuarioGeralDto
    }
};

export default connect(mapStateToProps, {
    limparUltimosHIstoricosUsuario
})(ModalHistoricoUsuario)